import { isArray } from './isArray';
import { isEmpty } from './isEmpty';
import { isNumber } from './isNumber';

export function reduceTotal(list, key) {
  if (!isArray(list) || isEmpty(list)) return 0;
  const numList = key === undefined ? list.map(Number) : list.map((item) => Number(item?.[key]));
  return numList.filter(isNumber).reduce((pv, cv) => (pv += cv), 0);
}
